import { bl_fi_nsti_stock_category_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class NstiStockCategoryContainerModel extends BaseContainerModel {
  bl_fi_nsti_stock_category: bl_fi_nsti_stock_category_RowClass = new bl_fi_nsti_stock_category_RowClass();
}

export class NstiStockCategoryQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
